// gloss
export const SDK_RESULT = { body: 'data', error: 'error', status: 'response.status' } as const;
